import logo from './johnny-bros-logo.svg';
import jb_Logo from './jb_horizontal.png';
import './App.scss';
import Help from './components/Help';
import Log from './components/Log';
import Reg from './components/Reg';
import Logout from './components/Logout';
import Game from './components/Game';
import Ranks from './components/Ranks';
import Terms from './components/Terms';
import Policy from  './components/Policy';
import Active from './components/Active';
import Intro from './components/Intro'; 
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Link
} from "react-router-dom";
import { SessionProvider } from './SessionContext';
import { SessionContext } from './SessionContext';
import { useContext } from 'react';


const App = () => {

  

  return (
    <SessionProvider>
    <Router>
      <main className="appwrap">
      <NavBar />
      <section>
      <Routes>
        <Route path="/" element={<Game />}></Route>
        <Route path="infoshare" element={<Game />}></Route>
        <Route path="help" element={<Help />}></Route>
        <Route path="intro" element={<Intro />}></Route>
        <Route path="log" element={<Log />}></Route>
        <Route path="reg" element={<Reg />}></Route>
        <Route path="reg/:code" element={<Reg />}></Route>
        <Route path="active" element={<Active />}></Route>
        <Route path="logout" element={<Logout />}></Route>
        <Route path="ranks" element={<Ranks />}></Route>
        <Route path="terms" element={<Terms />}></Route>
        <Route path="policy" element={<Policy />}></Route>
      </Routes>
      </section>
      <Footer />
      </main>
    </Router>
    </SessionProvider>
  );
}



const NavBar = () => {
  const [isLoggedIn, setIsLoggedIn] = useContext(SessionContext);
  let isActive = "";
  return (
  <>
  <ul className="circles">
                    <li key="1"></li>
                    <li key="2"></li>
                    <li key="3"></li>
                    <li key="4"></li>
                    <li key="5"></li>
                    <li key="6"></li>
                    <li key="7"></li>
                    <li key="8"></li>
                    <li key="9"></li>
                    <li key="10"></li>
            </ul>
  <header>
  <img id="infoshare-logo" src={logo} className="logo" alt="logo" />
  <h2 id="game-suptitle">Gra detektywistyczna</h2>
    <h1 id="game-title">Zaginięcie butów Roberta Lewandowskiego</h1>
    <nav className="mt-2 navbar is-justify-content-center" role="navigation" aria-label="main navigation">
        <div className="is-active">
        <div className="navbar-start is-flex is-justify-content-center">
            <NavLink to="/" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
            Gra
            </NavLink>
            {isLoggedIn ? (<>
            <NavLink to="/intro" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
            Intro
            </NavLink>
            </>
            ) : (<></>) }
            <NavLink to="/help" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
            Pomoc
            </NavLink>
            <NavLink to="/ranks" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
            Wyniki
            </NavLink>

            {!isLoggedIn ? (<>
            <NavLink to="/log" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
            Loguj
            </NavLink>
            <NavLink to="/reg" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
            Rejestruj
            </NavLink></>
            ) : (
              <NavLink to="/logout" className={isActive =>"navbar-item" + (!isActive ? " unselected" : "")}>
                Wyloguj {isLoggedIn}
              </NavLink>
            )}
          
        </div>
        </div>
    </nav>
  </header>
  </>
  );
}

const Footer = () => {
  return (
  <footer>
    <a
      className="brand-link"
      href="https://johnnybros.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img id="jb-logo" src={logo} className="logo" alt="logo" />
    </a>
    <div>
    <Link to="/terms">regulamin</Link> | <Link to="/policy">polityka</Link>
    </div>
  </footer>
  );
}

export default App;